import { load } from '@progress/kendo-react-intl';
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
import currencyData from 'cldr-core/supplemental/currencyData.json';
import weekData from 'cldr-core/supplemental/weekData.json';

import enGbNumbers from 'cldr-numbers-full/main/en-GB/numbers.json';
import enGbLocalCurrency from 'cldr-numbers-full/main/en-GB/currencies.json';
import enGbCaGregorian from 'cldr-dates-full/main/en-GB/ca-gregorian.json';
import enGbDateFields from 'cldr-dates-full/main/en-GB/dateFields.json';

import plNumbers from 'cldr-numbers-full/main/pl/numbers.json';
import plLocalCurrency from 'cldr-numbers-full/main/pl/currencies.json';
import plCaGregorian from 'cldr-dates-full/main/pl/ca-gregorian.json';
import plDateFields from 'cldr-dates-full/main/pl/dateFields.json';

import roNumbers from 'cldr-numbers-full/main/ro/numbers.json';
import roLocalCurrency from 'cldr-numbers-full/main/ro/currencies.json';
import roCaGregorian from 'cldr-dates-full/main/ro/ca-gregorian.json';
import roDateFields from 'cldr-dates-full/main/ro/dateFields.json';

import etNumbers from 'cldr-numbers-full/main/et/numbers.json';
import etLocalCurrency from 'cldr-numbers-full/main/et/currencies.json';
import etCaGregorian from 'cldr-dates-full/main/et/ca-gregorian.json';
import etDateFields from 'cldr-dates-full/main/et/dateFields.json';

import nlNumbers from 'cldr-numbers-full/main/nl/numbers.json';
import nlLocalCurrency from 'cldr-numbers-full/main/nl/currencies.json';
import nlCaGregorian from 'cldr-dates-full/main/nl/ca-gregorian.json';
import nlDateFields from 'cldr-dates-full/main/nl/dateFields.json';

import frNumbers from 'cldr-numbers-full/main/fr/numbers.json';
import frLocalCurrency from 'cldr-numbers-full/main/fr/currencies.json';
import frCaGregorian from 'cldr-dates-full/main/fr/ca-gregorian.json';
import frDateFields from 'cldr-dates-full/main/fr/dateFields.json';

import hrNumbers from 'cldr-numbers-full/main/hr/numbers.json';
import hrLocalCurrency from 'cldr-numbers-full/main/hr/currencies.json';
import hrCaGregorian from 'cldr-dates-full/main/hr/ca-gregorian.json';
import hrDateFields from 'cldr-dates-full/main/hr/dateFields.json';

/**
 * Update imports and load method to configure Internalization and Localization for supported locales/languages
 */

export const globalizationSetup = (): void => {
  load(
    likelySubtags,
    currencyData,
    weekData,

    enGbNumbers,
    enGbLocalCurrency,
    enGbCaGregorian,
    enGbDateFields,

    plNumbers,
    plLocalCurrency,
    plCaGregorian,
    plDateFields,

    roNumbers,
    roLocalCurrency,
    roCaGregorian,
    roDateFields,

    etNumbers,
    etLocalCurrency,
    etCaGregorian,
    etDateFields,

    nlNumbers,
    nlLocalCurrency,
    nlCaGregorian,
    nlDateFields,

    frNumbers,
    frLocalCurrency,
    frCaGregorian,
    frDateFields,

    hrNumbers,
    hrLocalCurrency,
    hrCaGregorian,
    hrDateFields
  );
};

/**
 * Update default language if needed. By default English. If no translation for other languages found, it will try with default english.
 */
